import React from 'react';
import { classIf } from '../../data/utils';
import { useLayout, useUISettings } from '../../UISettingsProvider';

function PrematchEmpty(props) {
    const uiSettings = useUISettings();
    const layout = useLayout();

    return (
        <div className={"griglia-centrale-sport col stringimento-sidebar " + layout.order.divCentrale} id="div-centrale">
            <div className="contenitore-schedine-sport">
                <div className={"competizione-interna dueColonne dueColonne_Template_1" + classIf(uiSettings.fullScreen, 'unaColonna')}>
                </div>
            </div>
        </div>
    );
}

export default PrematchEmpty;